import React from 'react'

export default function UpdateStatus() {
  return (
    <div>
      <h2>Cập nhật trạng thái</h2>
    </div>
  )
}
